import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
import DictsInfo from '../../components/dicts_info.jsx'

// import { Link } from 'react-router-dom';
// import GambarPointer1 from './img/pointer1.png'

// function refreshPage(){
//     setTimeout(()=>{
//       window.location.reload(false);
//     }, 500);
   
//   }


export default class CaraMengaturFormatPerataanTeksBeberapaSelPadaMsOfficeExcel2010 extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Cara Mengatur Format Perataan Teks Beberapa Sel Pada Microsoft Office Excel 2010</title>
        <meta name="description" content="belajar Microsoft Office Excel 2010, tutorial Microsoft Office Excel 2010, tutorial Microsoft Excel 2010 untuk pemula, berapa bagian Microsoft Excel"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Cara Mengatur Format Perataan Teks Beberapa Sel Pada Microsoft Office Excel 2010</h1>

                <p>Jenis perataan ini biasanya digunakan untuk mengatur perataan pada judul tabel yang mempunyai kata kata yang cukup panjang, untuk disesuaikan dengan lebar tabel tersebut.</p>
                <p>Untuk format perataan data terhadap beberapa sel (range), caranya sebagai berikut:</p>

                <div className= "w3-container" > 
                    <ol> 
                        <li>Pilih range yang berisi text untuk diber format perataan.</li> 
                        <li>Klik <b>Home</b> lalu pada bagian <b>Alignment</b> klik <b>Format Cell Alignment Dialog Box Launcher</b>, untuk membuka kotak dialog <b>Format Cells-Alignment</b> selanjutnya pada bagian drop down horizontal pilih <b>Center Across Selection</b>.</li> 
                        <li>Lalu klik tombol <b>OK</b>.</li> 
                        <li>Dan lihatlah hasilnya.</li> 
                    </ol> 
                </div>             

                <br/>
                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
